import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/common/Breadcrumb";
import { Loading } from "../../components/common/Loading";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

import { FieldArray, Form, Formik } from "formik";
import { XSelect } from "../../components/common/inputs/XSelect";
import { XTextArea } from "../../components/common/inputs/XTextArea";
import { XTextBox } from "../../components/common/inputs/XTextBox";
import { InvoiceFields } from "../../fields/InvoiceFields";
import { Endpoints } from "../../utils/Endpoints";
import InvoiceSummary from "../Sales/InvoiceSummary";
import { useFocus } from "../../hooks/useFocus";
import { ApiCore } from "../../helpers/api_helper";
import { amountToCurrency, currentDate, round, taxCalculator } from "../../utils/Helpers";
import { ISelectOption } from "../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../components/common/inputs/XDatePickerField";
import { XCheckbox } from "../../components/common/inputs/XCheckbox";
import { AxiosError, AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import { SupplierFields } from "../../fields/SupplierFields";
import { SupplierSchema } from "../../schemas/SupplierSchema";
import CreateForm from "../../components/forms/CreateForm";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { ISupplier } from "../../interfaces/suppliers/ISupplier";
import { ProductFields } from "../../fields/ProductFields";
import { ProductSchema } from "../../schemas/ProductSchema";
import { IProduct } from "../../interfaces/products/IProduct";
import { XSearchableSelect } from "../../components/common/inputs/XSearchableSelect";
import { toast } from "react-toastify";

const NewRequisition = () => {
  const [defaults, setDefaults] = useState<any>({});
  const [companies, setCompanies] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingRequisition, setloadingRequisition] = useState<boolean>(true);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const params = new URLSearchParams(useLocation().search);
  const invtype = params.get("invtype") ? params.get("invtype") : "sale";
  const [showSupplierDialog, setShowSupplierDialog] = useState<boolean>(false);
  const [showProductDialog, setShowProductDialog] = useState<boolean>(false);
  const [requisition, setRequisition] = useState<any>(null);

  const history = useHistory();

  const request = new ApiCore();

  const requisitionId = params.get("id") ? params.get("id") : null;

  if (requisitionId) {
    useEffect(() => {
      request
        .get(Endpoints.requistions + "/" + requisitionId)
        .then((response: AxiosResponse) => {
          setRequisition(response.data);
          setloadingRequisition(false);
        })
        .catch(error => {
          console.error(error);
        });
    }, []);
  }

  useEffect(() => {
    request
      .get(Endpoints.requistionsDefaults)
      .then((response: AxiosResponse) => {
        setDefaults(response.data);
        setLoading(false);
        if (!requisitionId) {
          setloadingRequisition(false);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    request
      .get(Endpoints.requistionsDefaults, {})
      .then((response: AxiosResponse) => {
        let options: any = [];
        options = response.data.companies.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data),
        }));
        setCompanies(options);

        options = [];
        options = response.data.products.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data),
        }));
        setProducts(options);


        options = [];
        options = response.data.users.map((data: any) => ({
          value: data.id,
          label: data.name,
          data: JSON.stringify(data),
        }));
        setUsers(options);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);


  const statuses: ISelectOption[] = [
    { value: "pending", text: "Pending" },
    { value: "approved", text: "Approved" },
    { value: "rejected", text: "Rejected" },
  ];

  let initialValues: any = {};
  if (requisition) {
    initialValues = {
      date: requisition.date ? requisition.date : "",
      company_id: requisition.company_id ? requisition.company_id : "",
      referenceno: requisition.referenceno ? requisition.referenceno : "",
      approvedby: requisition.approvedby ? requisition.approvedby : "",
      status: requisition.status ? requisition.status : "",
      remarks: requisition.remarks ? requisition.remarks : "",
      items: requisition.items.map((item: any) => {
        return item;
      }),
    };
  } else {
    initialValues = {
      date: currentDate(),
      company_id: "",
      approvedby: "",
      referenceno: "",
      status: "",
      remarks: "",
      items: [
        {
          product_id: "",
          particulars: "",
          rate: 0.0,
          quantity: 1,
          amount: 0.0,
        },
      ],
    };
  }

  const handleLineItemChange = (index: number) => (event: any) => { };

  const computeSubTotal = (items: [any]) => {
    const sum = items.reduce((accumulator, object) => {
      return accumulator + object.amount;
    }, 0);
    return sum;
  };

  const calculateGrandTotal = (items: [any], discount: number) => {
    const dis = computeDiscount(items, discount);
    const subTotal = computeSubTotal(items);
    return subTotal - dis;
  };

  const computeDiscount = (items: [any], discount: number) => {
    return (discount * computeSubTotal(items)) / 100;
  };

  const computeAmount = (index: number, item: any, setFieldValue: any) => {
    setFieldValue(`items.${index}.amount`, item.rate * item.quantity);
  };

  const computeTax = (items: [any]) => {
    const sum = items.reduce((accumulator, object) => {
      return (
        accumulator + taxCalculator(object)
      );
    }, 0);
    return sum;
  };

  const handleClickNewCompany = () => {
    setShowSupplierDialog(true);
  };

  const handleClickNewProduct = (index: number) => {
    setSelectedIndex(index);
    setShowProductDialog(true);
  };

  const handleCreateCompany = (supplier: ISupplier, f: any) => {
    const updatedCompanies = [
      ...companies,
      {
        value: supplier.id,
        label: supplier.name,
        data: JSON.stringify(supplier),
      },
    ];
    setCompanies(updatedCompanies);
    f("company_id", supplier.id);
  };

  const handleCreateProduct = (product: IProduct, f: any, values: any) => {
    const updatedProducts = [
      ...products,
      {
        value: product.id,
        label: product.name,
        data: JSON.stringify(product),
      },
    ];

    setProducts(updatedProducts);
    f(`items.${selectedIndex}.product_id`, product.id);

    f(`items.${selectedIndex}.quantity`, 1);
    f(`items.${selectedIndex}.rate`, product.costprice);
    f(`items.${selectedIndex}.particulars`, product.name);
    f(`items.${selectedIndex}.amount`, product.costprice);
  };

  const handleSubmit = (values: any) => {
    const request_body = values;
    for (let i = 0; i < request_body.items.length; i++) {
      delete request_body.items[i].tax;
      delete request_body.items[i].product;
    }
    request_body.requisitionitems_attributes = request_body.items;
    if (requisitionId) {
      request_body.id = requisitionId;
      toast
        .promise(request
          .update(Endpoints.requistions + "/" + requisitionId, request_body), {
          pending: "Please wait..",
          success: {
            render({ data }) {
              return "";
            },
          },
          error: {
            render({ data }) {
              return data;
            },
          },
        })
        .then((response: AxiosResponse) => {
          history.push("/requisitions-detail/" + response.data.id);
        })
        .catch((error: AxiosError) => {
          console.log(error);
        });
    } else {
      toast
        .promise(request
          .create(Endpoints.requistions, request_body), {
          pending: "Please wait..",
          success: {
            render({ data }) {
              return "";
            },
          },
          error: {
            render({ data }) {
              return data;
            },
          },
        })
        .then((response: AxiosResponse) => {
          history.push("/requisitions-detail/" + response.data.id);
        })
        .catch((error: AxiosError) => {
          console.log(error);
        });
    }

    console.log(values);
  };

  const getCurrencyCode = (currency: any) => {
    return currency ? currency.code : "UGX";
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>New Requisition | Treda</title>
        </MetaTags>

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Transactions" breadcrumbItem="New Requisition" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {(loading || loadingRequisition) && (
                    <Loading label="Loading requisition. Please wait." />
                  )}
                  {!loading && !loadingRequisition && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}
                      >
                        {({
                          isSubmitting,
                          setFieldValue,
                          values,
                          errors,
                          touched,
                        }) => (
                          <>
                            <XModal
                              title={"Add a company"
                              }
                              width={"lg"}
                              open={showSupplierDialog}
                              toggle={() =>
                                setShowSupplierDialog(!showSupplierDialog)
                              }
                              onClose={() => setShowSupplierDialog(false)}
                            >
                              <CreateForm
                                fields={SupplierFields}
                                initialValues={initialValues}
                                enableReinitialize={true}
                                submitEndpoint={Endpoints.companies}
                                submitButtonLabel={"save"}
                                validationSchema={SupplierSchema}
                                debug={false}
                                handleUpdate={(supplier: ISupplier) => {
                                  handleCreateCompany(supplier, setFieldValue);
                                }}
                                onClose={() => setShowSupplierDialog(false)}
                              />
                            </XModal>
                            <XModal
                              title={"Add a product"}
                              width={"lg"}
                              open={showProductDialog}
                              toggle={() =>
                                setShowProductDialog(!showProductDialog)
                              }
                              onClose={() => setShowProductDialog(false)}
                            >
                              <CreateForm
                                fields={ProductFields}
                                initialValues={initialValues}
                                submitEndpoint={Endpoints.products}
                                submitButtonLabel={"Create Product"}
                                validationSchema={ProductSchema}
                                debug={false}
                                handleUpdate={(product: IProduct) => {
                                  handleCreateProduct(
                                    product,
                                    setFieldValue,
                                    values
                                  );
                                }}
                                onClose={() => setShowProductDialog(false)}
                              />
                            </XModal>
                            <Form>
                              <Row>
                                <Col lg={2}>
                                  <XDatePickerField
                                    key="date"
                                    id="date"
                                    name={"date"}
                                    label={"Date"}
                                    touched={touched}
                                    onChange={setFieldValue}
                                    value={values.date}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={3}>
                                  <XSearchableSelect
                                    key="company_id"
                                    id="company_id"
                                    value={values.company_id}
                                    name={"company_id"}
                                    options={companies}
                                    label={"Company"}
                                    handleNewClick={e => {
                                      handleClickNewCompany();
                                    }}
                                    onChange={(value: any) => {
                                      setFieldValue("company_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XTextBox
                                    id="referenceno"
                                    type={"text"}
                                    value={values.referenceno}
                                    name={"referenceno"}
                                    label={"Ref No."}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSearchableSelect
                                    key="approvedby"
                                    id="approvedby"
                                    value={values.approvedby}
                                    name={"approvedby"}
                                    onChange={(value: any) => {
                                      setFieldValue("approvedby", value.value);
                                    }}
                                    options={users}
                                    label={"To be Approved By"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                                <Col lg={2}>
                                  <XSelect
                                    key="status"
                                    id="status"
                                    name={"status"}
                                    options={statuses}
                                    label={"Status"}
                                    touched={touched}
                                    errors={errors}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col lg={12}>
                                  <div
                                    className={
                                      "mt-4 border-top border-bottom pt-2 bg-light"
                                    }
                                  >
                                    <Row>
                                      <Col lg={3} className="px-4">
                                        <h6>Item</h6>
                                      </Col>
                                      <Col lg={1}>
                                        <h6>Qty</h6>
                                      </Col>
                                      <Col lg={2}>
                                        <h6>Rate</h6>
                                      </Col>
                                      <Col lg={3}>
                                        <h6>Particulars</h6>
                                      </Col>
                                      <Col lg={2}>
                                        <h6>Amount</h6>
                                      </Col>
                                      <Col lg={1}></Col>
                                    </Row>
                                  </div>
                                </Col>

                                <Col lg={12}>
                                  <FieldArray
                                    name={"items"}
                                    render={arrayHelpers => (
                                      <div className={"py-3"}>
                                        {values.items &&
                                          values.items.map(
                                            (item: any, index: number) => (
                                              <Row key={index}>
                                                <Col lg={3}>
                                                  <XSearchableSelect
                                                    onChange={(field: any) => {
                                                      const productId = field.value;
                                                      if (productId == -1) {
                                                        handleClickNewProduct(index);
                                                      } else {
                                                        setFieldValue(`items.${index}.product_id`, productId);
                                                        const data = JSON.parse(field.data);

                                                        setFieldValue(`items.${index}.quantity`, 1);
                                                        setFieldValue(`items.${index}.rate`, data.costprice);
                                                        setFieldValue(`items.${index}.particulars`, data.name);
                                                        setFieldValue(`items.${index}.amount`, data.costprice);
                                                      }
                                                    }}
                                                    allowAddNew={true}
                                                    options={products}
                                                    id={`items.${index}.product_id`}
                                                    name={`items.${index}.product_id`}
                                                    value={values.items[index].product_id}
                                                    touched={touched}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <XTextBox
                                                    id={`items.${index}.quantity`}
                                                    type={"text"}
                                                    handleBlur={event => {
                                                      computeAmount(
                                                        index,
                                                        item,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    name={`items.${index}.quantity`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={2}>
                                                  <XTextBox
                                                    id={`items.${index}.rate`}
                                                    type={"text"}
                                                    handleBlur={event => {
                                                      computeAmount(
                                                        index,
                                                        item,
                                                        setFieldValue
                                                      );
                                                    }}
                                                    name={`items.${index}.rate`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={3}>
                                                  <XTextBox
                                                    id={`items.${index}.particulars`}
                                                    type={"text"}
                                                    name={`items.${index}.particulars`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={2}>
                                                  <XTextBox
                                                    id={`items.${index}.amount`}
                                                    type={"text"}
                                                    onChange={handleLineItemChange(
                                                      index
                                                    )}
                                                    name={`items.${index}.amount`}
                                                    touched={touched}
                                                    errors={errors}
                                                  />
                                                </Col>
                                                <Col lg={1}>
                                                  <Button
                                                    className={
                                                      "btn btn-soft-danger"
                                                    }
                                                    to={"#"}
                                                  >
                                                    <i
                                                      className="fa fa-times"
                                                      onClick={() =>
                                                        arrayHelpers.remove(
                                                          index
                                                        )
                                                      }
                                                    ></i>
                                                  </Button>
                                                </Col>
                                              </Row>
                                            )
                                          )}
                                        <Button
                                          className={"btn btn-soft-primary"}
                                          type="button"
                                          onClick={() =>
                                            arrayHelpers.push({
                                              product_id: "",
                                              particulars: "",
                                              rate: "",
                                              quantity: "",
                                              amount: "",
                                            })
                                          }
                                        >
                                          <i className={"mdi mdi-plus"}></i> Add
                                          Item
                                        </Button>
                                      </div>
                                    )}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <XTextArea
                                  id="remarks"
                                  label="Remarks"
                                  name="remarks"
                                  size={{ lg: 12 }}
                                  touched={touched}
                                />
                              </Row>

                              <Row>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Sub total"}
                                    icon="mdi mdi-calculator"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        computeSubTotal(values.items)
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Tax"}
                                    icon="mdi mdi-percent"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(computeTax(values.items))
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    label={"Discount"}
                                    icon="mdi mdi-percent"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        computeDiscount(
                                          values.items,
                                          values.discount
                                        )
                                      )
                                    }
                                  />
                                </Col>
                                <Col lg={3}>
                                  <InvoiceSummary
                                    color={"light"}
                                    label={"Total"}
                                    icon="mdi mdi-calculator"
                                    value={
                                      getCurrencyCode(values.currency) +
                                      " " +
                                      amountToCurrency(
                                        calculateGrandTotal(
                                          values.items,
                                          values.discount
                                        )
                                      )
                                    }
                                  />
                                </Col>
                              </Row>

                              <div className="modal-footer">
                                <Button
                                  disabled={isSubmitting}
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Save
                                </Button>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NewRequisition;
